export default {"src":"/_next/static/media/bpps.3127265f.svg","height":42,"width":213,"blurWidth":0,"blurHeight":0};